module.exports = __webpack_public_path__ + "static/media/crown_g.cc6f927f.png";